import classificationModule from "./classificationModule"
import server from "../server"

classificationModule.service("classificationService", ["$http", function ($http) {
    this.getClassifiableTypes = () => {
        return $http.get(server.getServiceUrl("edition.classification") + "classifiableTypes")
            .then((response) => response.data)
    }
}])